import {ObjectIdentifier} from "../../../core/shared/basic/object-identifier";

export class WfProcessStartEvent {


    constructor(
        public processTypeId: number,
        public mainObject?: ObjectIdentifier,
        public objectIdentifiers?: ObjectIdentifier) {

    }


}
